import { createRouter, createWebHistory } from "vue-router";

import { RouteNames } from "utils/constants";
import { useRootStore } from "@/store/root";
import { routes } from "./routes";

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise(resolve => {
      if (to.name === RouteNames.Home && savedPosition) {
        // If navigating to/within dashboard always scroll to top
        // unless there's a savedPosition
        resolve({ left: 0, top: 0 });
      }

      resolve(savedPosition ?? undefined);
    });
  }
});

router.beforeEach((to, from, next) => {
  const rootStore = useRootStore();
  // Check if any of the routes require auth, and if so check if they're authenticated
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (rootStore.authenticated) {
      // Apply partial logout state to all authenticated paths
      if (!rootStore.member?.phoneNumber) {
        rootStore.logout();
        next({ name: RouteNames.SignIn });
        // Apply TOS guard to all authenticated paths
      } else if (
        !rootStore.member?.termsOfService &&
        to.name !== RouteNames.InitialSetupTOS
      ) {
        rootStore.setContinueToPath(to.fullPath);
        next({
          name: RouteNames.InitialSetupTOS,
          query: {
            email: rootStore.member?.email,
            hasPassword: "true"
          }
        });
      } else {
        next();
      }
    } else {
      rootStore.setContinueToPath(to.fullPath);
      next({ name: RouteNames.SignIn, query: { ...to.query } });
    }
  } else {
    next();
  }
});
